import { ArrowDownBoldCircleIcon } from './ArrowDownBoldCircleIcon';

/**
 * author: Austin Andrews
 * id E4AFC38F-01B3-452D-BDD7-A08EA66D53FA
 * name arrow-down-bold-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-bold-circle.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomBoldCircleIcon = ArrowDownBoldCircleIcon;
export default ArrowBottomBoldCircleIcon